import React, { useEffect } from "react";
import "./Styles.css";
import AOS from "aos";
import "aos/dist/aos.css";

const testimonials = [
  { text: "gupsy helped me gain confidence in speaking english. i practice a little every day, and it’s fun.", name: "Aarav (India)" },
  { text: "gupsy motivates me to keep up my workout routine. It’s like having a partner who always cheers me on.", name: "Maria (Spain)" },
  { text: "gupsy is perfect for study breaks. short chats help me reset my mood.", name: "Jun (Japan)" },
  { text: "I chatted with gupsy during my workout — it made the session lighter and more fun!", name: "Amira (Egypt)" },
  { text: "Starting my day with a positive chat on gupsy makes the whole day brighter.", name: "Yuki (Japan)" },
  { text: "gupsy is like a friend who reminds me to drink water and stretch!", name: "Elena (Italy)" },
  { text: "gupsy helps me relax before work. a few minutes of chatting makes me smile.", name: "Chen (China)" },
  { text: "I use gupsy while journaling. it helps me reflect and think deeper about my day.", name: "Noah (USA)" },
  { text: "gupsy motivates me to write my journal every evening. it feels like a conversation with myself.", name: "Isabella (Germany)" },
  { text: "gupsy helps me learn new english words in a fun way.", name: "Fatima (Morocco)" },
  { text: "gupsy reminds me to breathe and take breaks. it’s calming and genuine.", name: "Nadia (France)" },
  { text: "I use gupsy to practice French. it’s patient and fun to talk to.", name: "Leo (Brazil)" },
  { text: "gupsy helped me practice my job interviews. my answers sound much more natural now.", name: "Diego (Mexico)" },
  { text: "gupsy helps me stay focused while studying at home. it’s like a patient study buddy.", name: "Rina (Indonesia)" },
  { text: "gupsy keeps me company when i cook or clean. it turns daily chores into good moments.", name: "Aisha (Kenya)" },
];

export default function Testimonials() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const loopSlides = [...testimonials, ...testimonials]; // duplicate for infinite loop

  return (
    <section className="neo-section" data-aos="fade-up">
      <h2 className="neo-title" data-aos="fade-down">
        Testi<span className="highlight">monials</span>
      </h2>
      <div className="neo-carousel">
        <div className="neo-track">
          {loopSlides.map((t, i) => (
            <div className="neo-card" key={i} data-aos="fade-up" data-aos-delay={i * 100}>
              <p className="neo-text">“{t.text}”</p>
              <span className="neo-name">— {t.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
